module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cardSegmentParam",
    class: {
      selected: _vm.isSelected
    },
    attrs: {
      "id": "cardSegmentParam"
    }
  }, [_c('b-card', {
    staticClass: "card-segment"
  }, [_c('div', {
    staticClass: "img-segment",
    on: {
      "mouseover": _vm.mouseOver
    }
  }, [_c('div', {
    staticClass: "image-wrapper-segment"
  }, [_c('img', {
    attrs: {
      "src": _vm.Shot ? _vm.Shot : _vm.screenShot,
      "id": _vm.item.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-icon"
  }, [_c('div', {
    staticClass: "image-svg d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "img-svg",
    on: {
      "click": function($event) {
        return _vm.updateSegmentInGrapes(_vm.item, _vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit-c white-color-i"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-svg",
    on: {
      "click": function($event) {
        return _vm.duplicateThis(_vm.item, _vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "icon-duplicate-c white-color-i"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-svg"
  }, [_c('b-dropdown', {
    attrs: {
      "size": "lg",
      "variant": "link",
      "toggle-class": "text-decoration-none",
      "no-caret": "",
      "id": 'dropdown-' + _vm.indexDropDown
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function() {
        return [_c('i', {
          staticClass: "icon-more-c white-color-i"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.editSegment(_vm.item)
      }
    }
  }, [_c('svg', {
    staticClass: "svg mr",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 11.361 33.412"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M37.431,53.379H35.256a.519.519,0,0,0-.1-.074,2.791,2.791,0,0,1-1.671-3.365c.986-4.063,2-8.12,3.007-12.18a12.7,12.7,0,0,0,.3-1.708.4.4,0,0,0-.531-.474,3.214,3.214,0,0,0-.668.231c-.495.207-.976.451-1.474.642A.839.839,0,0,1,33,36.237v-.792a8.973,8.973,0,0,1,1.139-1.307c1.49-1.173,3.007-2.292,4.555-3.412A5.128,5.128,0,0,1,39.75,30.2a2.566,2.566,0,0,1,1.54-.16,2.983,2.983,0,0,1,2.466,3.849q-1.434,5.868-2.88,11.736a15.7,15.7,0,0,0-.334,1.935.378.378,0,0,0,.548.428c.364-.11.708-.287,1.063-.431.428-.187.872-.358,1.3-.521a.628.628,0,0,1,.715.207.668.668,0,0,1,.07.769,2.85,2.85,0,0,1-.411.632,11.1,11.1,0,0,1-1.16,1.119A32,32,0,0,1,37.431,53.379Z",
      "transform": "translate(-33 -19.967)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M46.49,8.237a4.1,4.1,0,1,1,2.911-1.2A4.113,4.113,0,0,1,46.49,8.237Z",
      "transform": "translate(-39.246 -0.01)"
    }
  })]), _vm._v("\n                  Informations\n                ")]), _vm._v(" "), _c('b-dropdown-item', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.handleDelete(_vm.item)
      }
    }
  }, [_c('svg', {
    staticClass: "action-btn mr",
    attrs: {
      "width": "24px",
      "height": "20px",
      "viewBox": "0 0 16 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.14285714,17.7777778 C1.14285714,19.0055556 2.16571429,20 3.42857143,20 L12.5714286,20 C13.8342857,20 14.8571429,19.0055556 14.8571429,17.7777778 L14.8571429,4.44444444 L1.14285714,4.44444444 L1.14285714,17.7777778 Z M16,1.11111111 L12,1.11111111 L10.8571429,0 L5.14285714,0 L4,1.11111111 L0,1.11111111 L0,3.33333333 L16,3.33333333 L16,1.11111111 Z",
      "id": "Shape",
      "fill": "red",
      "fill-rule": "nonzero"
    }
  })])]), _vm._v("\n                  Supprimer")])], 1)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-segment d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "resizer-text"
  }, [_c('span', {
    staticClass: "title-segment",
    on: {
      "click": function($event) {
        return _vm.showSlides(_vm.item)
      }
    }
  }, [_vm._v("\n          " + _vm._s(this.item.title) + "\n        ")]), _vm._v(" "), (_vm.item.author) ? _c('div', {
    staticStyle: {
      "margin-top": "0.1em"
    }
  }, [_vm._v("\n          Par "), _c('span', {
    staticStyle: {
      "color": "#2196f3"
    }
  }, [_vm._v(" " + _vm._s(_vm.createdPar()) + " ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nb-screen"
  }, [_vm._v(_vm._s(_vm.item.screens.length) + " " + _vm._s(_vm.$t('screens.screen')) + "(s)")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2523395e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSegment/Card.vue
// module id = 818
// module chunks = 1 3